import { render } from "./ReservationFeed.vue?vue&type=template&id=556692d8&scoped=true"
import script from "./ReservationFeed.vue?vue&type=script&lang=ts"
export * from "./ReservationFeed.vue?vue&type=script&lang=ts"

import "./ReservationFeed.vue?vue&type=style&index=0&id=556692d8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-556692d8"

export default script